import { pxToRem } from '@/Client/Styles/pxToRem';
import { Component, ReactNode } from 'react';
import { logError } from '../Lib/logger';

type ErrorBoundaryProps = {
  children: ReactNode;
  componentName: string;
  fallback?: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false, error: undefined };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    logError(`Component error in ${this.props.componentName}`, error, {
      componentName: this.props.componentName,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div
          style={{
            padding: '40px 20px',
            textAlign: 'center',
            maxWidth: '600px',
            margin: '0 auto',
          }}
        >
          <h2 style={{ fontSize: pxToRem(24), marginBottom: '16px', color: '#333' }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: pxToRem(16), color: '#666', marginBottom: '24px' }}>
            We've been notified and are looking into it. Please try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              fontSize: pxToRem(16),
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
